var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.542a7.458 7.458 0 100 14.916 7.458 7.458 0 000-14.916zM.792 10a9.208 9.208 0 1118.416 0A9.208 9.208 0 01.792 10z",
    fill: "#000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 5.792c.483 0 .875.391.875.875v6.666a.875.875 0 11-1.75 0V6.667c0-.484.392-.875.875-.875z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.792 10c0-.483.392-.875.875-.875h6.666a.875.875 0 110 1.75H6.667A.875.875 0 015.792 10z",
    fill: "#000"
  })));
}
export default SvgPlusCircle;